import * as THREE from 'three';

let loader = new THREE.TextureLoader();

const createExampleBg = (aspectRatio, bgAspect) => {
  return createThreeBgScene('https://s3.us-west-1.amazonaws.com/statics.vision.remotepc.com/app/timeslice/2019/12/c61a3828-c951-4eaf-9af8-1029d8b895a6.jpg', aspectRatio, bgAspect)
};

const createThreeBgScene = (imageUrl, aspectRatio) => {
  return new Promise((resolve, reject)  => {
    loader.load( imageUrl, function( texture ) {
      let bgAspect = texture.image.width / texture.image.height;
      let left = 2 * aspectRatio / -2;
      let right = 2 * aspectRatio / 2;
      let top = 1, bottom = -1;

      let bgWidth = right - left;
      let bgHeight = bgWidth / bgAspect;

      if(bgAspect < 1) {
        bgHeight = 2;
        bgWidth = bgHeight * bgAspect
      }

      let backgroundMesh = new THREE.Mesh(
        new THREE.PlaneGeometry(bgWidth , bgHeight, 0),
        new THREE.MeshBasicMaterial({
          map: texture
        })
      );

      backgroundMesh.material.depthTest = false;
      backgroundMesh.material.depthWrite = false;


      let backgroundScene = new THREE.Scene();
      let backgroundCamera = new THREE.OrthographicCamera(left, right, top, bottom, -1, 1);
      backgroundScene.add( backgroundCamera );
      backgroundScene.add( backgroundMesh );
      resolve({backgroundScene, backgroundCamera})
    });
  })
};

export {
  createExampleBg,
  createThreeBgScene
}


